import { render, staticRenderFns } from "./SolutionDetail.vue?vue&type=template&id=5455b980"
import script from "./SolutionDetail.vue?vue&type=script&lang=js"
export * from "./SolutionDetail.vue?vue&type=script&lang=js"
import style0 from "./SolutionDetail.vue?vue&type=style&index=0&id=5455b980&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_cache-loader@4.1.0_webpack@4.47.0__css-load_84b6d598d32b1da7294c0119ce301628/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports